<template>
    <div class="delivery-time-wrapper">
        <component is="style" v-html="useCss ? useCssValue : false"></component>
        <div v-if="$ceres.isShopBuilder || checkAvailibilityID.includes(currentVariation.variation.availability.id) && feiertage.length > 1" class="delivery-time-container" :class="'av_' + currentVariation.variation.availability.id">
            <!-- Frontend -->
            <div :class="'bg-' + appearance" v-if="!$ceres.isShopBuilder" :style="roundedCorners ? { borderRadius: roundedCornersValue + 'px'} : {}">
                <!-- Widget Shipping regular days -->
                <template v-if="countdown > 0 && !sunday && !holiday && currentDay != 6">
                    <div :class="this.$attrs.spacingclasses" v-html="updatedHTML" :style="this.$attrs.inlinepadding + this.$attrs.inlinemargin"></div>
                </template>
                <!-- Widget Shipping for saturdays -->
                <template v-else-if="countdown > 0 && !sunday && !holiday && currentDay == 6 && saturdayWeekday">
                    <div :class="this.$attrs.spacingclasses" v-html="updatedHTML" :style="this.$attrs.inlinepadding + this.$attrs.inlinemargin"></div>
                </template>
                <!-- Widget Shipping next (possible) Day -->
                <template v-else-if="(countdown <= 0 || sunday || holiday || currentDay == 6 && !saturdayWeekday ) && showShippingTimeHtmlNoShippingToday">
                    <div :class="this.$attrs.spacingclasses" v-html="updatedHTMLNo" :style="this.$attrs.inlinepadding + this.$attrs.inlinemargin"></div>
                </template>
            </div>

            <!-- Shopbuilder -->
            <code style="font-size:75%!important;padding-bottom:10px;display:block" v-if="$ceres.isShopBuilder && showShopBuilderInfo">Vorschau!<template v-if="countdown < 0"> Negativer Countdown nur im Shopbuilder!</template></code>
            <div :class="'bg-' + appearance" v-if="$ceres.isShopBuilder" :style="roundedCorners ? { borderRadius: roundedCornersValue + 'px'} : {}">
                <div v-if="isNaN(parseFloat(countdown))" :class="this.$attrs.spacingclasses" :style="this.$attrs.inlinepadding + this.$attrs.inlinemargin">{{ $translate("DeliveryTimeWidget::Template.notValid") }}</div>
                <div v-else :class="this.$attrs.spacingclasses" v-html="updatedHTML" :style="this.$attrs.inlinepadding + this.$attrs.inlinemargin"></div>
            </div>
            <hr v-if="$ceres.isShopBuilder && !showShopBuilderInfo && showShippingTimeHtmlNoShippingToday">
            <code style="font-size:75%!important;padding-bottom:10px;display:block;padding-top:10px" v-if="$ceres.isShopBuilder && showShippingTimeHtmlNoShippingToday && showShopBuilderInfo">Vorschau bei Versand am nächstmöglichen Tag:</code>
            <div :class="'bg-' + appearance" v-if="$ceres.isShopBuilder && showShippingTimeHtmlNoShippingToday" :style="roundedCorners ? { borderRadius: roundedCornersValue + 'px'} : {}">
                <div v-if="isNaN(parseFloat(countdown))" :class="this.$attrs.spacingclasses" :style="this.$attrs.inlinepadding + this.$attrs.inlinemargin">{{ $translate("DeliveryTimeWidget::Template.notValid") }}</div>
                <div v-else :class="this.$attrs.spacingclasses" v-html="updatedHTMLNo" :style="this.$attrs.inlinepadding + this.$attrs.inlinemargin"></div>
            </div>
        </div>
        <!--<hr>
        <p v-if="feiertage.includes($date(Date.now()).format('YYYY-MM-DD'))">
            Feiertag: Heute ist ein Feiertag in <strong>{{ shippingTimeState }}</strong>
        </p>

        <hr>
        <p><strong>Aktuelle Verfügbarkeits-ID der Variante:</strong> {{ currentVariation.variation.availability.id }}</p>
        <hr>
        <strong>Bundesland:</strong> {{ shippingTimeState }}<br>
        <strong>Versand erfolgt bis</strong> {{ placeholderTime }} Uhr
        <hr>
        <p><strong>Sichtbar nur bei folgenden Verfügbarkeit-Ids:</strong></p>
        <span v-for="id in checkAvailibilityID">
            {{ id }}
        </span>
        <hr>
        <p v-if="shippingTimeSaturday" style="background-color: green; color: white; padding: 15px">Versand Montag bis Samstag</p>
        <p v-else style="background-color: green; color: white; padding: 15px">Versand Montag bis Freitag</p>

        <p>Tag heute: <strong>{{ $date(Date.now()).format('YYYY-MM-DD') }}</strong></p>
        <hr>
        <h3>Wochentag Abfrage</h3>

        <p>Es ist Wochentag Nummer: <strong>{{ $date(Date.now()).get('day') }}</strong></p>

        <p v-if="$date(Date.now()).get('day') != 0">
            Ist heute Sonntag: <strong>Nein</strong>
        </p>
        <p v-else>Ist heute Sonntag: <strong>Ja</strong></p>
        <p v-if="feiertage.includes($date(Date.now()).format('YYYY-MM-DD'))">
            Feiertag: Heute ist ein Feiertag in <strong>{{ shippingTimeState }}</strong>
        </p>
        <p v-else>
            Feiertag: Heute ist kein Feiertag in <strong>{{ shippingTimeState }}</strong>
        </p>
        <p>Versand Samstag?: <strong><template v-if="shippingTimeSaturday">Ja</template> <template v-else>Nein</template></strong></p>

        <h1>Test: {{ $date(Date.now()).format('YYYY-MM-DD' + 'T' + placeholderTime + ':00+01:00') }}</h1>
        <h1>Test: {{ $date(Date.now()).format() }}</h1>

        <hr>
        <p><strong>Feiertage:</strong></p>
        <span v-for="(feiertag, index) in feiertage">
            <span>{{ feiertag }}</span><br>
        </span>-->
    </div>
</template>

<script>
    var d = new Date();
    var n = d.getFullYear();

    import VueDayjs from 'vue-dayjs-plugin';
    Vue.use(VueDayjs);

    // add leading zero in countdown
    function pad( num, size ) {
        num = num.toString();
        while ( num.length < size ) num = "0" + num;
        return num;
    }

    export default {
        data: function() {
            return {
                currentDay: this.$date(Date.now()).get('day'),
                feiertage: [],
                updatedHTML: this.shippingTimeHtml,
                updatedHTMLNo: this.shippingTimeHtmlNoShippingToday,
                countdown: false,
                countdownHour: false,
                countdownMinute: false,
                placeholderCountdown: "",
                checkAvailibilityID: [],
                interval: null,
                saturdayWeekday: false,
                sunday: false,
                holiday: false,
                nextShippingDay: ""
            }
        },
        props: {
            shippingTimeState: null,
            appearance: null,
            roundedCorners: null,
            roundedCornersValue: null,
            placeholderTime: null,
            shippingTimeVisibility: null,
            shippingTimeSaturday: false,
            shippingTimeHtml: null,
            showShippingTimeHtmlNoShippingToday: true,
            shippingTimeHtmlNoShippingToday: null,
            useCss: null,
            useCssValue: null,
            showShopBuilderInfo: null
        },
        inject: {
            itemId: {
                default: null
            }
        },
        computed: {
            currentVariation() {
                return this.$store.getters[`${this.itemId}/currentItemVariation`]
            }
        },
        mounted() {
            // get holidays
            var self = this,
            feiertage = [];

            // availability ids (string) to array
            var av = this.shippingTimeVisibility.split(',').map(Number);
            this.checkAvailibilityID = av;

            // update widget every minute
            this.interval = setInterval(() => {
                this.updateWidget();
            },60000);

            $.getJSON('https://feiertage-api.de/api/?jahr=' + n + '&nur_land=' + this.shippingTimeState).done(function( data ) {
                for (var i = 0; i < Object.values(data).length; i++) {
                    feiertage.push(Object.values(data)[i].datum);
                }
                self.feiertage = feiertage;

                // update after json recieved
                self.updateWidget();
            })
        },
        methods: {
            updateWidget() {
                // check DST (Daylight Saving Time)
                Date.prototype.stdTimezoneOffset = function () {
                    var jan = new Date(this.getFullYear(), 0, 1);
                    var jul = new Date(this.getFullYear(), 6, 1);
                    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
                }

                Date.prototype.isDstObserved = function () {
                    return this.getTimezoneOffset() < this.stdTimezoneOffset();
                }

                var today = new Date();
                if (today.isDstObserved()) {
                    var ship = this.$date( Date.now() ).format( 'YYYY-MM-DD' + 'T' + this.placeholderTime )
                } else {
                    var ship = this.$date( Date.now() ).format( 'YYYY-MM-DD' + 'T' + this.placeholderTime + ':00+01:00' )
                }

                // check if Saturday = weekday
                if (this.currentDay == 6 && this.shippingTimeSaturday) {
                    this.saturdayWeekday = true;
                }

                var hour = this.$translate("DeliveryTimeWidget::Template.hour"),
                    minutes = this.$translate("DeliveryTimeWidget::Template.minutes"),
                    minute = this.$translate("DeliveryTimeWidget::Template.minute");

                var now = this.$date( Date.now() ),
                    isHoliday = this.feiertage.includes( this.$date( Date.now() ).format( 'YYYY-MM-DD' ) ),
                    diffHour = now.diff( this.$date( ship ), 'hour' ) * - 1,
                    diffMinute = now.diff( this.$date( ship ), 'minute' ) * - 1,
                    countdownMinute = diffMinute - ( diffHour * 60 );

                // back to init for placeholder replacement
                this.updatedHTML = this.shippingTimeHtml;
                this.updatedHTMLNo = this.shippingTimeHtmlNoShippingToday;

                // calculate time differences
                this.countdown = diffMinute;
                this.countdownHour = diffHour;
                this.countdownMinute = countdownMinute;

                // show only minutes if less than 1 hour remains
                if ( diffHour == '00' && App.language == "de" ) {
                    if (countdownMinute == 1) {
                        this.placeholderCountdown = countdownMinute + minute;
                    } else {
                        this.placeholderCountdown = countdownMinute + minutes;
                    }
                } else {
                    this.placeholderCountdown = diffHour + ":" + pad( countdownMinute, 2 ) + hour;
                }

                // replace placeholders
                this.updatedHTML = this.updatedHTML.replace( /%time/g, this.placeholderTime );
                this.updatedHTML = this.updatedHTML.replace( /%countdown/g, this.placeholderCountdown );

                // check if Sunday
                if ( this.currentDay == 0 ) {
                    this.sunday = true;
                }

                // check if Holiday
                if ( isHoliday ) {
                    this.holiday = true;
                }

                // calculate next shipping day
                let i = 0;

                if (this.shippingTimeSaturday) {
                    do {
                        i += 1;
                        this.nextShippingDay = now.add(i, 'day').format('YYYY-MM-DD');
                    } while ( !( this.$date( this.nextShippingDay ).get('day') != 0 && !this.feiertage.includes(this.nextShippingDay) ) );
                } else {
                    do {
                        i += 1;
                        this.nextShippingDay = now.add(i, 'day').format('YYYY-MM-DD');
                    } while ( !( this.$date( this.nextShippingDay ).get('day') != 6 && this.$date( this.nextShippingDay ).get('day') != 0 && !this.feiertage.includes(this.nextShippingDay) ) );
                }

                // translate number day to human language
                var Weekdays = [
                    this.$translate("DeliveryTimeWidget::Template.day0"),
                    this.$translate("DeliveryTimeWidget::Template.day1"),
                    this.$translate("DeliveryTimeWidget::Template.day2"),
                    this.$translate("DeliveryTimeWidget::Template.day3"),
                    this.$translate("DeliveryTimeWidget::Template.day4"),
                    this.$translate("DeliveryTimeWidget::Template.day5"),
                    this.$translate("DeliveryTimeWidget::Template.day6")
                ];

                // handling tomorrow wording
                if (now.get('day') + 1 == this.$date( this.nextShippingDay ).get('day')) {
                    this.updatedHTMLNo = this.updatedHTMLNo.replace( /%day/g, this.$translate("DeliveryTimeWidget::Template.tomorrow") );
                } else {
                    this.updatedHTMLNo = this.updatedHTMLNo.replace( /%day/g, Weekdays[this.$date(this.nextShippingDay).get('day')] );
                }
            }
        }
    }
</script>
